import { AnalyticsService } from 'base/analytics';
import { exists } from 'base/helpers';
import { useRightClickMenu } from 'base/ui/menu';
import { AnyMenuItem, menuDivider, menuItem } from 'base/ui/menu_model';
import React from 'react';
import { shortcut, useKeyboardShortcuts } from '../../keyboard_shortcuts';
import { ProjectEditingActions } from '../editing_actions/project';
import { SectionEditingActions } from '../editing_actions/section';
import {
  pageAskAiMenu,
  SelectionActions,
  selectionActionsMenu,
} from '../selection_actions';

export function useCommonSectionInteractions({
  sectionEditing,
  projectEditing,
  selectionActions,
  analytics,
  isSelected,
  extraMenuItems = [],
}: {
  sectionEditing: SectionEditingActions | undefined;
  projectEditing: ProjectEditingActions | undefined;
  selectionActions: SelectionActions;
  analytics: AnalyticsService;
  isSelected: boolean;
  extraMenuItems: AnyMenuItem[];
}): [
  onContextMenu: (e: React.MouseEvent) => void,
  menuPortal: React.ReactNode,
] {
  const addAbove =
    sectionEditing &&
    (() => {
      sectionEditing.addAbove();
      analytics.track({
        event: 'blocks/add-section',
        method: 'blank',
      });
    });
  const addBelow =
    sectionEditing &&
    (() => {
      sectionEditing.addBelow();
      analytics.track({
        event: 'blocks/add-section',
        method: 'blank',
      });
    });

  useKeyboardShortcuts(isSelected, {
    [shortcut('Enter', { cmd: true })]: addBelow,
    [shortcut('ArrowUp')]: sectionEditing?.moveUp,
    [shortcut('ArrowUp', { shift: true })]: sectionEditing?.moveUp,
    [shortcut('ArrowDown')]: sectionEditing?.moveDown,
    [shortcut('ArrowDown', { shift: true })]: sectionEditing?.moveDown,
  });

  const globalItems = [
    sectionEditing?.makeGlobal
      ? menuItem({
          label: 'Create global section',
          onClick: sectionEditing.makeGlobal,
        })
      : null,
    sectionEditing?.unlinkGlobal
      ? menuItem({
          label: 'Unlink instance',
          onClick: sectionEditing.unlinkGlobal,
        })
      : null,
  ].filter(exists);

  const menu =
    projectEditing && sectionEditing
      ? [
          ...selectionActionsMenu(
            selectionActions,
            pageAskAiMenu(selectionActions.editing),
          ),
          menuDivider(),
          menuItem({
            label: 'Add section above',
            onClick: addAbove,
          }),
          menuItem({
            label: 'Add section below',
            onClick: addBelow,
            shortcut: '⌘↵',
          }),
          ...(globalItems.length ? [menuDivider(), ...globalItems] : []),
          ...(extraMenuItems.length ? [menuDivider(), ...extraMenuItems] : []),
        ]
      : [];
  const [onContextMenu, portal] = useRightClickMenu(menu);
  return [onContextMenu, portal];
}
